export function trackById<T extends { id?: number | string }>(
  index: number,
  item: T,
): number | string {
  const id = item?.id;
  if (typeof id === 'number' && id > 0) return id;
  if (typeof id === 'string' && id.length > 0) return id;
  return `tmp-${index}`;
}

export function trackByIndex(index: number): number {
  return index;
}

export function trackByAgentId(_index: number, item: { agentId: string }): string {
  return item.agentId;
}
